import style from "./style.module.css";
import Header from '@components/Header';
import Container from '@components/Container';
import Footer from '@components/Footer';

const BlogBindGrenade = () => {
    return (
        <div>
            <Header type="mini"/>
            <section className={style.contacts_section}>
                <Container>
                    <div className={style.content_article}>
                        <h2>Бинды на бросок гранат в CS 2</h2>

                        <p>Правильное использование гранат — основа тактики в CS 2. В этой статье мы расскажем, как сэкономить драгоценные секунды с помощью биндов: быстрые команды на молотовы, дымовые, флешки и другие гранаты. А также покажем, как работают jumpthrow, runthrow и runjumpthrow — техники, которые помогут попадать гранатами точно в цель и выигрывать важные раунды.</p>

                        <h3>Быстрые бинды на гранаты</h3>
                        <p>Чтобы моментально доставать нужную гранату, используйте следующие консольные команды:</p>
                        <ul>
                            <li><code>bind "Кнопка" "use weapon_molotov"</code> — коктейль Молотова;</li>
                            <li><code>bind "Кнопка" "use weapon_smokegrenade"</code> — дымовая граната;</li>
                            <li><code>bind "Кнопка" "use weapon_flashbang"</code> — светошумовая граната;</li>
                            <li><code>bind "Кнопка" "use weapon_hegrenade"</code> — осколочная граната;</li>
                            <li><code>bind "Кнопка" "use weapon_decoy"</code> — ложная граната.</li>
                        </ul>

                        <h3>Jumpthrow — бросок с прыжка</h3>
                        <p>Эта техника используется для дальних и точных бросков гранат. Она особенно полезна, если нужно попасть в строго определённую позицию.</p>
                        <p><strong>Бинд:</strong> <code>bind "Кнопка" "+jump;-attack;-attack2;-jump"</code></p>

                        <h3>Runthrow — бросок на ходу</h3>
                        <p>Позволяет кидать гранаты на ходу с максимальной точностью. Подходит для фейков и динамичных атак.</p>
                        <p><strong>Бинд:</strong> <code>bind "Кнопка" "+forward;-attack;-forward"</code></p>

                        <h3>Runjumpthrow — бросок на ходу с прыжком</h3>
                        <p>Комбинация предыдущих техник. Используется для самых дальних и точных гранат.</p>
                        <p>
                        alias "+RunJThrow" "+forward;+jump;-attack"
                        alias "-RunJThrow" "-forward;-jump"
                        bind "Кнопка" "+RunJThrow"
                        </p>

                        <p>С помощью этих биндов вы сможете использовать гранаты максимально эффективно в любой ситуации. Не забывайте тренировать броски на карте и проверять свои бинды в игре!</p>
                    </div>
                </Container>
            </section>
            <Footer/>
        </div>
    )
}

export default BlogBindGrenade;
